import { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TopSection from "../../../CommonComponents/TopSection";
import StorageIcon from "@mui/icons-material/Storage";
import Toolbar from "../../../CommonComponents/common/Toolbar";
import DetailsPageLowerLayer from "../../../Components/DetailsPageLowerLayer/DetailsPageLowerLayer";
import { fetchCurrencyConversionDetailsData } from "../../../services/CurrencyConversion/CurrencyConversionDetailsService";
import { Box, CircularProgress } from "@mui/material";

const CurrencyConversionDetail = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [monthlyExchangeRateData, setMonthlyExchangeRateData] = useState(false);
    const [yearlyExchangeRateData, setYearlyExchangeRateData] = useState(false);
    const [loading, setLoading] = useState(true);
    const breadcrumbArray = ["Master Data", "Currency Conversion", "Currency Conversion Detail"];

    useEffect(() => {
        // Start 1 second timer when component mounts
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer); // cleanup on unmount
    }, []);

    useEffect(() => {
        const fetchAllData = async () => {
            const data = await fetchCurrencyConversionDetailsData(id);
            setMonthlyExchangeRateData(data?.monthlyRates);
            setYearlyExchangeRateData(data?.yearlyRates);
        };
        fetchAllData();
    }, [id]);

    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate("core/master-data/currency-conversion");
        }
    };

    const toolbarProps = {
        icon: <StorageIcon />,
        onBack: handleBack,
        hideExpandButton: true,
        toolbarMeta: {
            heading: id,
            metaLine: {
                currencyTo: 'USD'
            }
        },
    };

    const exchangeRateColumns = useMemo(() => [
        { headerName: "Currency From", field: "currencyFrom" },
        { headerName: "Currency To", field: "currencyTo" },
        { headerName: "Time", field: "time" },
        { headerName: "Quantity", field: "quantity" },
        { headerName: "Fiscal Year", field: "fiscalYear" },
        { headerName: "Fiscal Period", field: "fiscalPeriod" }
    ], []);

    const monthlyExchangeRateTab = useMemo(() => ({
        label: "Monthly Exchange Rate",
        columns: exchangeRateColumns,
        rows: monthlyExchangeRateData,
    }), [monthlyExchangeRateData, exchangeRateColumns]);

    const yearlyExchangeRateTab = useMemo(() => ({
        label: "Yearly Exchange Rate",
        columns: exchangeRateColumns,
        rows: yearlyExchangeRateData,
    }), [yearlyExchangeRateData, exchangeRateColumns]);

    const tabs = [monthlyExchangeRateTab, yearlyExchangeRateTab];

    // Show full-page spinner if loading
    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
                <CircularProgress size={60} />
            </Box>
        );
    }

    return (
        <div>
            <TopSection breadcrumbArray={breadcrumbArray} hideHeader={true} headerName={""} hideTitle={true} />
            <Toolbar {...toolbarProps} />
            <DetailsPageLowerLayer tabs={tabs} />
        </div>
    );
};

export default CurrencyConversionDetail;